import {
  GET_SHIPMENT_HELPERS,
  GET_SHIPMENT_STATUS_FILTERS,
  SET_SHIPMENT,
  NEW_SHIPMENT
} from 'src/store/mutation-types'
export default {
  [GET_SHIPMENT_HELPERS] (state, shipmentHelpers) {
    state.shipmentHelpers = shipmentHelpers
  },
  [GET_SHIPMENT_STATUS_FILTERS] (state, shipmentStatusFilters) {
    state.shipmentStatusFilters = shipmentStatusFilters
  },
  [SET_SHIPMENT] (state, shipment) {
    state.shipment = shipment
  },
  [NEW_SHIPMENT] (state) {
    state.shipment = {
      id: 0,
      address_from: {
        city_code: '',
        district_code: ''
      },
      address_to: {
        city_code: '',
        district_code: ''
      },
      picker: {
      },
      receiver: {
      },
      parcel: {
        quantity: 1,
        cod_amount: 0,
        length: 0,
        width: 0,
        height: 0,
        weight: 0,
        amount: 0
      },
      metadata: '',
      return_type: 0,
      payer: 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/shipment/store/mutations.js